
    import { defineComponent, computed } from 'vue';
    import DefaultLayout from './layouts/DefaultLayout.vue'
    import Login from './layouts/login/UserLogin.vue'
    import { useStore } from 'vuex'   
    import './assets/styles/style.css'

    export default defineComponent({
        name: 'App',
        components:{
            DefaultLayout,
            Login,
        },
        setup(){
            const store = useStore()
            const isLoaded = true
            const layout = computed(() => {
                if(store.state.user.loggedIn === true) {
                    return 'DefaultLayout'
                 } 
                else {
                    return 'DefaultLayout'
                }
                //return 'DefaultLayout'
            });
            return {isLoaded, layout, store}
        },
    })
